import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export function dateToNgbDate(date: any): NgbDate | null {
    return date instanceof Date
        ? new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
        : null
}

export function ngbDateToDate(date: any): Date | null {
    return date instanceof NgbDate || isNgbDate(date)
        ? new Date(Date.UTC(date.year, date.month - 1, date.day))
        : null
}

export function isNgbDate(date: any): boolean {
    return date !== null
        && date !== undefined
        && typeof date === 'object'
        && 'day' in date
        && 'month' in date
        && 'year' in date
        && Number.isInteger(date.day)
        && Number.isInteger(date.month)
        && Number.isInteger(date.year)
}